<template>
  <div>
    <div :style="'position: relative; overflow: hidden; overflow-x: auto;'" class="scroll-wrapper" ref="scroll">
      <div class="scroll-content">
        <!-- {{ screenHeight }} -->
        <img :src="map.image" :style="'height: 100vh;'" />
        <div @click="clickElement(element)" v-for="(element, idx) in map.elements" :key="idx" class="element-div" :style="getElementDivStyle(element)">
          <element-preview :element="element" :bg-scale="bgScale"></element-preview>
        </div>
      </div>
    </div>
    <ui-popup ref="popup" :ui="ui" v-on:click.native="contentClick($event)" :close-function="closeFunction"></ui-popup>
  </div>
</template>
<script>
import ElementPreview from './elementPreview'
import UiPopup from '../ui/popup.vue'
import { ImagePreview } from 'vant'

export default {
  name: 'MapLine',
  components: {
    ElementPreview,
    UiPopup
  },
  props: {
    projectId: 0,
    projectUid: 0,
    member: {},
    apiroot: '',
    map: {},
    ui: {}
  },
  data () {
    return {
      scroll: null,
      mapLeft: 0,
      bgWidth: null,
      bgHeight: null,
      bgScale: 1,
      content: null,
      elementAudio: null,
      isClosePause: false
    }
  },
  watch: {
  },
  methods: {
    contentClick (event) {
      const target = event.target
      if (target.tagName === 'IMG') {
        let imgReg = /<img.*?(?:>|\/>)/gi
        let srcReg = /src="(.*?)"/i
        let widthReg = /width="(.*?)"/i

        let arr = this.content.match(imgReg)
        let srcArr = []
        for (let i = 0; i < arr.length; i++) {
          let src = arr[i].match(srcReg)
          let width = arr[i].match(widthReg)
          if (!width || parseInt(width[1]) > 100) {
            srcArr.push(src[1])
          }
        }
        var idx = null
        for (var _idx in srcArr) {
          if (srcArr[_idx] === target.src) {
            idx = parseInt(_idx)
          }
        }
        if (idx === null) {
          return false
        }

        var previewObj = {
          closeable: true,
          images: srcArr,
          startPosition: idx
        }
        ImagePreview(previewObj)
      }
    },
    clickElement (element) {
      if (element.is_box === 1) {
        this.content = element.box_content
        this.$refs.popup.openMsg(element.box_title, element.box_content)
        var postData = {}
        postData['UID'] = this.member['UID'] ? this.member['UID'] : '_NONO_'
        postData['id'] = this.projectId
        postData['pu_id'] = this.projectUid
        postData['status'] = 200
        postData['key'] = 'openBox'
        this.$http.post(this.apiroot + '/open/method', postData).then((response) => {
        })
      }
      if (element.music) {
        this.elementAudio = new Audio()
        this.elementAudio.loop = element.music_loop === 1
        this.elementAudio.src = element.music
        this.elementAudio.play()
        if (element.music_time === 0) {
          this.isClosePause = false
          setTimeout(() => {
            this.elementAudio.pause()
          }, element.music_timer * 1000)
        } else {
          this.isClosePause = true
        }
      }
    },
    closeFunction () {
      if (this.isClosePause) {
        this.elementAudio.pause()
      }
    },
    runBgScale () {
      var height = window.innerHeight
      var me = this
      var image = new Image()
      image.src = this.map.image
      image.onload = function () {
        me.bgWidth = image.width
        me.bgHeight = image.height
        me.bgScale = height / image.height
      }
    },
    getElementDivStyle (element) {
      var style = ''
      if (element.symbol_y_offset) {
        style += 'top: ' + (this.bgScale * (element.symbol_y_offset + element.y_offset)) + 'px;'
      } else {
        style += 'top: ' + (this.bgScale * element.y_offset) + 'px;'
      }
      if (element.symbol_x_offset) {
        style += 'left: ' + (this.bgScale * (element.symbol_x_offset + element.x_offset)) + 'px;'
      } else {
        style += 'left: ' + (this.bgScale * element.x_offset) + 'px;'
      }
      style += 'width: ' + (this.bgScale * element.width) + 'px;'
      style += 'height: ' + (this.bgScale * element.height) + 'px;'
      return style
    },
    getMapImageStyle () {
      var style = 'height: 100%; position: absolute;'
      return style
    },
    refBgScale () {
      if (this.bgHeight) {
        var height = window.innerHeight
        this.bgScale = height / this.bgHeight
        setTimeout(() => {
          this.refBgScale()
        }, parseInt(Math.random() * 1000))
      }
    }
  },
  mounted () {
    this.runBgScale()
  }
}
</script>
<style>
.element-div { position: absolute; }
.element-item { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-size: 100%; background-repeat: no-repeat; background-position: center; }
.scroll-wrapper {
  width: 100vw;
  height: 100vh;
  white-space: nowrap;
  border-radius: 5px;
  overflow: hidden;
}
.scroll-content {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/map/line.vue